import type {
  QuotaManagementMode,
  QuotaManagementState,
  StateSlice,
} from '@src/stores/types.ts';
import type {FeatureRef} from '@src/types/featureCollections.ts';
import type {Product} from '@src/types/products.ts';

const initialState = {
  active: false,
  mode: 'reserve' as QuotaManagementMode,
  reserve: {
    selectedFeatureRefs: [],
    selectedProduct: null,
  },
  release: {
    selectedFeatureRefs: [],
    selectedProduct: null,
  },
};

export const setQuotaManagementSlice: StateSlice<
  QuotaManagementState
> = set => ({
  ...initialState,
  setShowQuotaManagement: (active: boolean) =>
    set(
      state => {
        state.quotaManagement.active = active;
      },
      undefined,
      'quotaManagement/setShowQuotaManagement',
    ),
  selectReserveFeatureRefs: (featureRefs: FeatureRef[]) =>
    set(
      state => {
        state.quotaManagement.reserve.selectedFeatureRefs = featureRefs;
      },
      undefined,
      'quotaManagement/selectReserveFeatureRefs',
    ),
  selectReleaseFeatureRefs: (featureRefs: FeatureRef[]) =>
    set(
      state => {
        state.quotaManagement.release.selectedFeatureRefs = featureRefs;
      },
      undefined,
      'quotaManagement/selectReleaseFeatureRefs',
    ),
  selectReserveProduct: (product: Product | null) =>
    set(
      state => {
        state.quotaManagement.reserve.selectedProduct = product;
      },
      undefined,
      'quotaManagement/selectReserveProduct',
    ),
  selectReleaseProduct: (product: Product | null) =>
    set(
      state => {
        state.quotaManagement.release.selectedProduct = product;
      },
      undefined,
      'quotaManagement/selectReleaseProduct',
    ),
  setMode: (mode: QuotaManagementMode) =>
    set(
      state => {
        state.quotaManagement.mode = mode;
      },
      undefined,
      'quotaManagement/setMode',
    ),

  reset: () =>
    set(
      state => {
        state.quotaManagement.reserve.selectedFeatureRefs = [];
        state.quotaManagement.reserve.selectedProduct = null;
        state.quotaManagement.release.selectedFeatureRefs = [];
        state.quotaManagement.release.selectedProduct = null;
      },
      undefined,
      'quotaManagement/setMode',
    ),
});
